import { FamilyMember } from '@/types';
import { getAncestorLineage } from './ancestors';

export function searchMembers(
  query: string,
  members: FamilyMember[],
  excludeId?: string
): Array<{ member: FamilyMember; lineage: string }> {
  if (!query || query.length < 2) return [];

  // Clean and normalize the search query
  const searchTerms = query
    .toLowerCase()
    .replace(/\s+بن\s+/g, ' ') // Remove "بن" from search
    .trim()
    .split(/\s+/); // Split into terms

  // Get all members with their lineage
  const membersWithLineage = members
    .filter(member => member.id !== excludeId)
    .map(member => ({
      member,
      lineage: getAncestorLineage(member.id, members)
    }));

  // Filter members based on search terms
  const results = membersWithLineage.filter(({ lineage }) => {
    const normalizedLineage = lineage.toLowerCase().replace(/\s+بن\s+/g, ' ');
    
    // Check if search terms appear at the start of the lineage
    let currentIndex = 0;
    for (const term of searchTerms) {
      const index = normalizedLineage.indexOf(term, currentIndex);
      // If term not found or not in sequence from start, exclude this result
      if (index === -1 || index > currentIndex + 1) return false;
      currentIndex = index + term.length;
    }
    return true;
  });

  // Sort by exact match first
  return results
    .sort((a, b) => {
      const aLineage = a.lineage.toLowerCase().replace(/\s+بن\s+/g, ' ');
      const bLineage = b.lineage.toLowerCase().replace(/\s+بن\s+/g, ' ');
      const searchPattern = searchTerms.join(' ');
      
      // Exact match at start gets priority
      const aExactMatch = aLineage.startsWith(searchPattern);
      const bExactMatch = bLineage.startsWith(searchPattern);
      
      if (aExactMatch && !bExactMatch) return -1;
      if (!aExactMatch && bExactMatch) return 1;
      
      return 0;
    })
    .slice(0, 5); // Limit to 5 results
}